import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal, Header, Icon, Grid, Popup } from "semantic-ui-react";
import { withCancel } from "@api/utils";
import { documentApi } from "@api/documents";
import { DateTime } from "luxon";

export default class ExtendModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overbooked: false,
      open: false,
    };
  }

  componentDidMount() {
    this.fetchCirculation();
  }

  componentWillUnmount() {
    this.cancellableCirculation && this.cancellableCirculation.cancel();
  }

  isDueToday = () => {
    const { loanDetails } = this.props;
    const { end_date: endDate } = loanDetails.metadata;

    if (!endDate) return false;

    const currentDate = DateTime.now();
    const loanEndDate = DateTime.fromISO(endDate);
    return currentDate.hasSame(loanEndDate, "day");
  };

  fetchCirculation = async () => {
    const { loanDetails, sendErrorNotification } = this.props;
    const { document_pid } = loanDetails.metadata;
    try {
      this.cancellableCirculation = withCancel(documentApi.get(document_pid));
      const response = await this.cancellableCirculation.promise;
      const circulation = response.data.metadata.circulation;
      this.setState({
        overbooked: circulation.overbooked === true,
      });
    } catch (error) {
      if (error !== "UNMOUNTED") {
        sendErrorNotification(
          "Something went wrong while checking if the literature is overbooked.",
          "If the problem persists, please contact technical support."
        );
      }
    }
  };

  extend = () => {
    const { loanAction } = this.props;
    loanAction();
    this.hide();
  };

  hide = () => this.setState({ open: false });
  show = () => this.setState({ open: true });

  render() {
    const { pid, isLoading } = this.props;
    const { open, overbooked } = this.state;

    //Check if due today
    const dueToday = this.isDueToday();

    //If not due today, show disabled button with tooltip
    if (!dueToday) {
      const { loanDetails } = this.props;
      const { end_date: endDate } = loanDetails.metadata;
      const loanEndDate = DateTime.fromISO(endDate);
      const dueDateText = loanEndDate.toLocaleString({
        month: "long",
        day: "numeric",
      });

      const tooltipContent = `Loan extension available on due date (${dueDateText}).`;

      return (
        <Popup
          trigger={
            <div>
              <Button size="small" fluid disabled content="Extend" />
            </div>
          }
          content={tooltipContent}
          position="top left"
          size="small"
          inverted
        />
      );
    }

    return overbooked ? (
      <Modal
        size="small"
        trigger={
          <Button
            primary
            fluid
            content="Extend"
            onClick={this.show}
            loading={isLoading}
            disabled={isLoading}
          />
        }
        open={open}
        onClose={this.hide}
      >
        <Header content={`Extend Loan #${pid}`} />
        <Modal.Content>
          <Grid>
            <Grid.Column width={1}>
              <Icon name="warning sign" color="red" size="large" />
            </Grid.Column>
            <Grid.Column width={15}>
              <p>
                {`Are you sure you want to extend the loan #${pid}?
            This literature is overbooked.`}
              </p>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.hide}>
            Cancel
          </Button>
          <Button primary onClick={this.extend}>
            Extend
          </Button>
        </Modal.Actions>
      </Modal>
    ) : (
      <Button
        size="small"
        fluid
        primary
        onClick={this.extend}
        loading={isLoading}
        disabled={isLoading}
      >
        Extend
      </Button>
    );
  }
}

ExtendModal.propTypes = {
  pid: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  loanAction: PropTypes.func.isRequired,
  loanDetails: PropTypes.object.isRequired,
  sendErrorNotification: PropTypes.func.isRequired,
};
